import './Components/GlobalJQuery'

// Import Twitter Bootstrap v4
//import 'bootstrap'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/tooltip'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/popover'
import 'bootstrap/js/dist/scrollspy'
import 'bootstrap/js/dist/alert'

// Import webfonts
import 'typeface-lato'

// Import global components
import './Components/LazySizes'
import './Components/SlickCarousel'
import './Components/MediumZoom'
import './Components/Tooltip'
import './Components/SmoothScroll'

// Import atomic components
//import '../Fusion/Component/Atom/BackToTop/BackToTop'
import '../Fusion/Component/Molecule/Carousel/Carousel'
import '../Fusion/Component/Molecule/Navigation/Main/Main'
import '../Fusion/Component/Molecule/Navigation/UnitSystem/UnitSystem'

// Import other packages
import '../../../../Gann.Consent/Resources/Private/JavaScript/Consent'
import '../../../../Gann.Contact/Resources/Private/JavaScript/Form'
import '../../../../Gann.Search/Resources/Private/JavaScript/Search'
import '../../../../Gann.Product/Resources/Private/JavaScript/Product'
import '../../../../Gann.Product.Category/Resources/Private/JavaScript/Category'
import '../../../../Gann.Product.Application/Resources/Private/JavaScript/Application'
import '../../../../Gann.Product.Download/Resources/Private/Fusion/Component/Template/DownloadManager/DownloadManager'
import '../../../../Gann.Wiki/Resources/Private/JavaScript/Wiki'
import '../../../../Gann.Checkout/Resources/Private/JavaScript/Checkout'

// Bundle these because they depend on jQuery
import '../../../../../Packages/Tms/TMS.Basics.Text/Resources/Public/JavaScript/Table'
import '../../../../../Packages/Tms/TMS.Form.Bootstrap/Resources/Public/JavaScript/FieldDependend'
import '../../../../../Packages/Tms/TMS.LanguageNotification/Resources/Public/JavaScript/LanguageNotification'

// Styles
import '../Styles/Main.scss'
